<template>
  <div class="reactivate-parent">
    <a v-if="!showingForm"
       class="btn btn-danger flex gap-x-xs align-items-center justify-center"
       @click="showingForm = true">
      <i class="fa-solid fa-arrow-rotate-right"></i>
      <span>Reactivate Parent</span>
    </a>

    <div v-else class="bg-gray-50 m-t-sm border rounded-sm border-solid border-gray-300 p-sm">
      <h3 class="m-t-none m-b-sm">Reactivate Parent</h3>
      <p>
        This restores their WrestlingIQ login and adds them back to the team's default messaging groups.
        Rosters synced to a paid session are restored automatically. Manually built rosters and custom messaging groups are not, so you may need to re-add them by hand.
      </p>
      <div v-if="alumniWrestlerCount > 0" class="checkbox m-b-sm">
        <label>
          <input type="checkbox" v-model="reactivateWrestlers">
          Also reactivate {{ wrestlerLabel }}
        </label>
      </div>
      <div class="flex flex-col gap-y-xs">
        <ladda-button @lbClicked="reactivateParentPressed" el-class="btn-danger btn-block w-full" :loading="loading">
          Yes, reactivate
        </ladda-button>
        <button v-on:click="showingForm = false" class="btn btn-default btn-block w-full">Cancel</button>
      </div>
      <small v-show="error"><span class="text-danger">{{ errorMessage }}</span></small>
    </div>
  </div>
</template>

<script>
import LaddaButton from '../../shared/ladda_button.vue';

export default {
  name: 'reactivate-parent-form',
  components: { LaddaButton },
  props: {
    parentId: {
      type: Number,
      required: true,
    },
    // Alumni (graduated) wrestlers this parent is a guardian of. Drives the checkbox.
    alumniWrestlerCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false, // Loading is a network variable (hitting the api)
      showingForm: false,
      reactivateWrestlers: true,

      error: false,
      errorMessage: 'Error, please try again later or contact support.',
    };
  },
  computed: {
    wrestlerLabel() {
      if (this.alumniWrestlerCount === 1) {
        return 'their 1 deactivated wrestler';
      }
      return `their ${this.alumniWrestlerCount} deactivated wrestlers`;
    },
  },
  methods: {
    reactivateParentPressed: _.throttle(function () {
      const vm = this;
      // If this is a duplicate request, just return
      if (vm.loading === true) {
        return;
      }
      vm.loading = true;
      vm.error = false;

      const url = vm.$apiService.parentReactivateUrl(vm.parentId);
      axios.post(url, { reactivate_wrestlers: vm.alumniWrestlerCount > 0 && vm.reactivateWrestlers })
        .then(() => {
          vm.loading = false;

          vm.$notificationManager.emit('show-toast', 'Parent is now active');
          window.location.reload();
        })
        .catch((error) => {
          vm.loading = false;
          const apiMessage = _.get(error, 'response.data.errors[0]');
          vm.errorMessage = apiMessage || 'Error, please try again later or contact support.';
          vm.error = true;
        });
    }, 500),
  },
};
</script>
